import {
  customerSkillTitle,
  customerSkillSearchText,
  isClientVisibleSkill,
} from "@/components/agent/skillPresentation";
import {
  categorizeSkill,
  BRAND_SPECIFIC_SKILLS,
  STOCK_HERMES_SKILLS,
} from "@/components/agent/skillTaxonomy";

export const isRemoved = (skill) =>
  ["deleted", "removed", "archived"].includes(
    String(skill.status).trim().toLowerCase(),
  );
export const skillKey = (skill) =>
  String(skill.id || `${skill.scope}:${skill.name}`);
export const SKILL_GROUP_LABELS = Object.freeze({
  hermes: "Default Hermes",
  growthos: "GrowthOS",
  brand: "Brand Specific",
});
export const skillGroup = (skill) => {
  const category = categorizeSkill(skill);
  if (category === STOCK_HERMES_SKILLS) return "hermes";
  return category === BRAND_SPECIFIC_SKILLS ? "brand" : "growthos";
};
export const skillOrigin = (skill) => SKILL_GROUP_LABELS[skillGroup(skill)];
export const skillTitle = customerSkillTitle;
export const versionLabel = (value) =>
  value === null || value === undefined || value === ""
    ? "Not reported"
    : `v${String(value).replace(/^v/i, "")}`;
export const stateLabel = (value) =>
  String(value || "Not reported")
    .replace(/[-_]+/g, " ")
    .replace(/^\w/, (letter) => letter.toUpperCase());

export function visibleSkills(
  skills,
  { search = "", group = "all", showRemoved = false, sort = "name" } = {},
) {
  const query = search.trim().toLowerCase();
  return skills
    .filter(
      (skill) =>
        isClientVisibleSkill(skill) &&
        (showRemoved || !isRemoved(skill)) &&
        (group === "all" || skillGroup(skill) === group) &&
        (!query ||
          `${customerSkillSearchText(skill)} ${skillOrigin(skill)}`
            .toLowerCase()
            .includes(query)),
    )
    .sort((a, b) =>
      sort === "updated"
        ? (Date.parse(b.changedAt) || 0) - (Date.parse(a.changedAt) || 0) ||
          skillTitle(a).localeCompare(skillTitle(b))
        : skillTitle(a).localeCompare(skillTitle(b)),
    );
}

export function skillChanges(skill, changes = []) {
  const history = changes
    .filter(
      (item) =>
        item.skillName === skill.name &&
        categorizeSkill(item) === categorizeSkill(skill),
    )
    .map((item) => ({ ...item }));
  if (
    (skill.whatChanged || skill.whyChanged) &&
    !history.some(
      (item) =>
        item.whatChanged === skill.whatChanged &&
        item.whyChanged === skill.whyChanged,
    )
  ) {
    history.push({
      id: "registry-latest",
      action: skill.lastAction,
      occurredAt: skill.changedAt,
      whatChanged: skill.whatChanged,
      whyChanged: skill.whyChanged,
    });
  }
  return history.sort(
    (a, b) => (Date.parse(b.occurredAt) || 0) - (Date.parse(a.occurredAt) || 0),
  );
}
